import Component from '../Component';
import Inspector from '../inspector/Inspector';
import Fragment from '../inspector/Fragment';

const { BaseControl } = wp.components;

export default class Link extends Component {
  static attributes(name) {
    return {
      type: 'array',
      source: 'query',
      selector: '[bb="' + name + '"]',
      query: {
        url: {
          type: 'string',
          source: 'attribute',
          attribute: 'href',
        },
        target: {
          type: 'string',
          source: 'attribute',
          attribute: 'target',
        },
      },
    };
  }

  render() {
    let link = this.link();

    if (this.isView()) {
      if (!link) {
        return this.props.children;
      }

      return (
        <a
          bb={this.name}
          href={link.url}
          className={this.props.className}
          target={link.target}
          rel="noopener noreferrer"
        >
          {this.props.children}
        </a>
      );
    }

    return (
      <Fragment>
        <span
          bb={this.name}
          href={link ? link.url : ''}
          className={this.props.className}
          target={link ? link.target : ''}
        >
          {this.props.children}
        </span>

        <Inspector>
          <Inspector.Body title="Link">
            <Inspector.Row>
              <BaseControl
                id="link_url"
                label="URL"
              >
                <input
                  type="text"
                  id="link_url"
                  value={link ? link.url : ''}
                  onChange={event => {
                    let link = this.link() || {};
                    link.url = event.target.value;
                    this.setAttr(link);
                    this.setAttr(Date.now(), 'timestamp');
                  }}
                />
              </BaseControl>
            </Inspector.Row>

            <Inspector.Row>
              <BaseControl
                id="link_target"
                label="New window"
                help="Check if is external URL"
              >
                <input
                  type="checkbox"
                  id="link_target"
                  checked={link && link.target == '_blank'}
                  onChange={event => {
                    let link = this.link() || {};
                    link.target = event.target.checked ? '_blank' : null;
                    this.setAttr(link);
                    this.setAttr(Date.now(), 'timestamp');
                  }}
                />
              </BaseControl>
            </Inspector.Row>
          </Inspector.Body>
        </Inspector>
      </Fragment>
    );
  }

  link() {
    let link = this.attr('link');

    if (Array.isArray(link) && link.length > 0) {
      link = link[0];
    }

    return link;
  }
}
